<template>
  <main class="card blog">
    <div class="card-body">
      <h1 class="h2">Новости и статьи</h1>
      <p v-if="loading" role="status">Загружаем публикации…</p>
      <p v-else-if="error" role="alert">{{ error }}</p>
      <p v-else-if="!news.length">Публикаций пока нет.</p>
      <article v-for="post in news" :key="post.id" class="blog-block d-md-flex text-start mt-4">
        <img
          :src="post.image || require('@/assets/images/logo_info.svg')"
          :alt="post.title"
          class="blog-block__image"
          loading="lazy"
          decoding="async"
        />
        <div class="ms-md-4 col">
          <h2 class="h3">
            <router-link :to="`/blog/${post.id}`">{{ post.title }}</router-link>
          </h2>
          <p class="content">{{ truncateContent(post.content) }}</p>
          <router-link :to="`/blog/${post.id}`" class="btn-link">Читать полностью</router-link>
          <p class="date mt-4">
            <time :datetime="post.created_at">{{ formatDate(post.created_at) }}</time>
          </p>
        </div>
      </article>
      <nav v-if="total > 20" class="d-flex flex-wrap gap-3 mt-4" aria-label="Страницы новостей">
        <router-link v-if="page > 1" :to="page === 2 ? '/blog' : `/blog?page=${page - 1}`" rel="prev"
          >← Предыдущая</router-link
        >
        <span>Страница {{ page }} из {{ Math.ceil(total / 20) }}</span>
        <router-link v-if="page * 20 < total" :to="`/blog?page=${page + 1}`" rel="next">Следующая →</router-link>
      </nav>
    </div>
  </main>
</template>
<script>
  import { defineComponent, ref, watch, computed } from 'vue';
  import NewsService from '@/services/news';
  import { useRoute } from 'vue-router';

  export default defineComponent({
    name: 'Blog',
    setup() {
      const route = useRoute();
      const news = ref([]);
      const total = ref(0);
      const loading = ref(true);
      const error = ref('');
      const page = computed(() => Number(route.query.page || 1));
      let request = 0;
      watch(
        page,
        async (number) => {
          const current = ++request;
          loading.value = true;
          error.value = '';
          news.value = [];
          try {
            if (!Number.isSafeInteger(number) || number < 1) throw new Error('invalid page');
            const result = await NewsService.all(number);
            if (current !== request) return;
            news.value = result.result;
            total.value = result.count;
          } catch (_) {
            if (current === request)
              error.value =
                'Не удалось открыть эту страницу новостей. Вернитесь к первой странице или попробуйте позже.';
          } finally {
            if (current === request) loading.value = false;
          }
        },
        { immediate: true }
      );
      const truncateContent = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('script, style').forEach((node) => node.remove());
        const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > 160 ? text.slice(0, 157) + '…' : text;
      };
      const formatDate = (value) => new Date(value).toLocaleDateString('ru-RU');
      return { news, total, loading, error, page, truncateContent, formatDate };
    },
  });
</script>
<style lang="scss">
  @import '@/assets/styles/Blog';
</style>
